<template>
    <div>
        <b-row>
            <b-col>
                <b-button v-b-modal="id +'modal-prevent-closing'" size="sm"
                          variant="primary" class="mr-1" :aria-describedby="describedby">{{AttachOrReplace}} Supervisory Plan</b-button>
            </b-col>
        </b-row>

        <b-modal  hide-footer
                  :id="id +'modal-prevent-closing'"
                  ref="modal"
                  title="Add Documentation"
                  @show="resetModal"
                  @hidden="resetModal"
                  @ok="handleOk">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                        :state="$v.type.$dirty ? !$v.type.$error : null"
                        label="Type of Attachment"
                        label-for="type-input"
                        invalid-feedback="Type of Attachment is required">
                    <b-form-select id="type-input" v-model="type"
                                   :state="$v.type.$dirty ? !$v.type.$error : null"
                                   :options="attachmentTypeOptions">
                        <template v-slot:first>
                            <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                    </b-form-select>
                </b-form-group>
                

                <BaseRadioInput v-model="applyToAll"
                                :v="$v.applyToAll"
                                label="Apply to all pending applicants you're supervising?"
                                :options=opts.yesNoBoolOptions
                                slug="applyToAll" />

                <form-group
                        :state="$v.file.$dirty ? !$v.file.$error : null"
                        label="File to Attach"
                        label-for="file-input"
                        :validator="$v.file">
                    <b-form-file
                            id="file-input"
                            v-model="file"
                            accept="application/pdf, text/plain, image/*, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            :state="$v.file.$dirty ? !$v.file.$error : null"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here...">
                    </b-form-file>
                </form-group>

                <b-button type="submit" variant="primary" :disabled="isDisabled">Submit</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import maxFileSize from '@/validators/maxFileSize'
    import fileType from "@/validators/fileType";
    import { commonOptions } from '@/mixins/commonOptions.js'

    export default {
        data() {
            return {
                type: null,
                file: null,
                attachments: [],
                isDisabled: false,
                attachmentTypeOptions: [],
                applyToAll: false
            }
        },
        mixins: [
            commonOptions
        ],
        props: {
            id: [String],
            describedby: [String],
            appId: [String],
            hasSupervisoryPlan: [Boolean]
        },
        validations: {
            file: { required, maxFileSize: maxFileSize(), fileType: fileType() },
            applyToAll: { required },
            type: { required },
        },
        created() {
            this.loadTypeOptions();
        },
        computed:{
            AttachOrReplace: function() {
                return this.hasSupervisoryPlan?'Replace':'Attach';
            }
        },
        methods: {
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.nameState = valid
                return valid
            },
            resetModal() {
                this.name = null
                this.nameState = null
            },

            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },

            handleSubmit() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return
                }
                this.isDisabled = true
                const fd3 = new FormData()
                fd3.append('file', this.file)
                fd3.append('type', this.type)
                fd3.append('applyToAll', this.applyToAll)
                fd3.append('appId', this.appId)


                axios.post(`${process.env.VUE_APP_API_BASE_URL}/Attachments/supervisor`, fd3)
                    .then(response => {
                        this.file = null
                        this.type = null
                        this.$emit('attachment-added', response.data)
                        let modalId = this.id + 'modal-prevent-closing';
                        this.$nextTick(() => {
                            this.$v.$reset()
                            this.isDisabled = false
                            this.$bvModal.hide(modalId)
                        })
                    })
            },
            loadTypeOptions() {
                let type;
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/Attachments/public/allTypes`,{ignoreHeader:true}).then(response => {
                    type = response.data.filter(x => x.code === "SP")[0];
                    this.attachmentTypeOptions.push({
                        value: type.code,
                        text: type.description
                    })
                });
            }
        }
    }
</script>